import { CelumPropertiesProvider } from '@celum/core';

export function resolveAssetPath(name: string): string {
  const isEmbed = CelumPropertiesProvider.properties.appProperties.formats.isEmbed ?? false;
  if (!isEmbed) {
    return name;
  }

  return 'formats-embed/' + name;
}
